export const firebaseTestConfig = {
   apiKey: 'AIzaSyDb-Y66oGQWS0vLSXprXD2xnTjzmajVd0Q',
   // See firebase.config.ts: must match FIRESTORE_DATABASE_ID in
   // functions/.env.test-oopsy-app.
   databaseId: 'test-oopsy-app',
   authDomain: 'test-oopsy-app.firebaseapp.com',
   projectId: 'test-oopsy-app',
   storageBucket: 'test-oopsy-app.firebasestorage.app',
   messagingSenderId: '884237303675',
   appId: '1:884237303675:web:ad1011624fe678f61007de',
   recaptchaSiteKey: '6LdnBdwsAAAAAGi1EPtl5CKluBmHyqbCV_3koke0',
};
